import { secureLocalStorageGet } from "../helpers";

export interface Permission {
    permission: string;
    trn_group: string;
    trn_sname: string;
    trn_type: number;
};

export const getPermissionList = () => {
    return secureLocalStorageGet("permissions")
    // return JSON.parse(<any>localStorage.getItem('permissions'));
}

export const checkPermission = (permission : string) => {
    const getPermissions=getPermissionList();

    if(getPermissions) {
        let check_permission=  getPermissions?.find(row => row.trn_sname===permission);

        return check_permission?.permission==="Y" || permission==='ALL';
    }
}

export const checkAnyPermission = (permissionList: any) => {
    let isAllow=false;
    const getPermissions=getPermissionList();

    for(let per of permissionList){

        if (per==='ALL'){
            isAllow=true;
            break;
        }

        let check_permission= getPermissions?.find(row => row.trn_sname===per);

        let yesOrNo=check_permission?.permission==="Y";

        if (yesOrNo){
            isAllow=true;
            break;
        }
    }



    return isAllow;
}
